import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import CKEditorComponent from '../../components/CKEditorComponent';
import FileUpload from '../../components/FileUpload';
import CheckboxInput from '../../components/CheckboxInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import serviceApi from '../../api/serviceApi';
import { useToast } from '../../contexts/ToastContext';

const AddService = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    excerpt: '',
    description: '',
    image: '',
    is_active: 1,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : (type === 'file' ? files[0] : value),
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleDescriptionChange = (content) => {
    setFormData({ ...formData, description: content });
    if (validationErrors.description) {
      setValidationErrors(prev => ({ ...prev, description: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      await serviceApi.createService(data);
      addToast('Service created successfully!', 'success');
      navigate('/services');
    } catch (err) {
      console.error('Failed to add service:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add service. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Service</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Service Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Service Name"
            error={validationErrors?.name?.[0]}
            required={true}
          />
          <TextInput
            label="Excerpt"
            name="excerpt"
            id="excerpt"
            value={formData.excerpt}
            onChange={handleChange}
            placeholder="Short description or summary"
            error={validationErrors?.excerpt?.[0]}
            required={true}
          />
          <CKEditorComponent
            label="Description"
            value={formData.description}
            onChange={handleDescriptionChange}
            error={validationErrors?.description?.[0]}
            required={true}
          />
          <FileUpload
            label="Service Image"
            name="image"
            id="image"
            onChange={handleChange}
            error={validationErrors?.image?.[0]}
            required={false} // Image is now optional
            currentFileUrl={null}
            onRemoveFile={null}
            fileType="image"
            fileName="Image"
          />
          <CheckboxInput
            label="Active"
            name="is_active"
            id="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Service
            </Button>
            <Button
              type="button"
              onClick={() => navigate('/services')}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddService;